module.exports = __webpack_public_path__ + "static/media/machineImg.b7a78345.png";